<template>
	<div>
		<div
			class="modal fade"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-focus="false"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="private-chef-spotlight">
						<button
							type="button"
							class="modal-close"
							@click="close"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<div class="modal-inner-content">
							<h1 class="modal-title">
								Private Chef: Chef Williams
							</h1>
							<h2 class="modal-subtitle">
								Exclusive meals, now prepared by renowned chefs.
								<br />
								$10-13 meals with free delivery.
							</h2>
							<button
								class="button button-primary"
								@click="clickCta"
							>
								Place Order
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-close {
	position: absolute;
	top: 15px;
	right: 5px;
}

.modal-close i {
	color: var(--gR-white);
}

.private-chef-spotlight {
	height: 226px;
	border-top-right-radius: 5px;
	border-top-left-radius: 5px;
	background: linear-gradient(
			180deg,
			rgba(16, 16, 16, 0.46) 0%,
			rgba(145, 145, 145, 0) 100%
		),
		url("/images/private-chef-spotlight.jpg");
	background-position: center;
	background-size: cover;
}

.modal-body {
	justify-content: flex-start;
}

.modal-title {
	font-size: 24px;
	margin-top: 20px;
	text-align: center;
}

.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	text-align: center;
	margin-bottom: 26px;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.modal-inner-content .button {
	flex-shrink: 0;
}

@media only screen and (max-width: 400px) {
	.modal-title {
		margin-top: 0;
	}
}
</style>

<script>
import { ExperimentType } from "@/enums/ExperimentType"
export default {
	name: "PrivateChefModal",
	data: function () {
		return {
			params: {}
		}
	},
	methods: {
		open() {
			let isModalOpen = $(this.$refs.modal).is(":visible")
			if (isModalOpen) {
				return
			}
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Experiment Modal CTA Opened",
				data: {
					type: ExperimentType.PRIVATE_CHEF
				}
			})
			this.params = this.$route.query
			$(this.$refs.modal).modal("show")
		},
		clickCta() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Experiment Modal CTA Clicked",
				data: {
					type: ExperimentType.PRIVATE_CHEF
				}
			})
			this.$router.push({
				path: `/${this.$route.params.slug}/menu/event/${this.params.eventId}`
			})
			this.close()
		},
		close() {
			this.params = {}
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
